<script lang="ts" context="module">
	export type Ribbon = {
		id: string
		message_html: string
		style: string
		background_color: string
	}
</script>

<script lang="ts">
	import { onMount } from 'svelte'

	const SECONDS_IN_A_DAY = 60 * 60 * 24

	export let ribbon: Ribbon

	const full_cookie_name = `closed_${ ribbon.id }_banner`
	let show = true


	console.log(`Ribbon`, ribbon)

	onMount(() => {
		if (document.cookie
			.split(`; `)
			.find(row => row.startsWith(full_cookie_name))
		) {
			show = false
		}
	})

	function on_click_close() {
		show = false
		document.cookie = `${ full_cookie_name }=true; Max-Age=${ 30 * SECONDS_IN_A_DAY }; SameSite=None; Secure; Path=/`
	}
</script>


{#if show}
	<div class=closable_banner style="--banner-background: { ribbon.background_color }">
		<div class=center_banner style={ribbon.style}>
			<div class=message>
				{@html ribbon.message_html}
			</div>
			<button
				on:click|preventDefault={on_click_close}
				type=button
				aria-label="Dismiss banner"
				class=close>✖</button>
		</div>
	</div>
{/if}

<style>
	.closable_banner {
		background: var(--banner-background);
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		font-family: 'Protipo Narrow';
	}
	.center_banner {
		display: flex;
		max-width: 1040px;
		margin: 0 auto;
		align-items: center;
	}
	.message {
		flex: 100% 0 1;
		text-align: center;
		padding: 10px 0 10px 10px;
		line-height: 20px;
	}
	.message :global(a) {
		color: #fff;
		text-decoration: underline;
	}
	.close {
		border: 0;
		background: none;
		padding: 20px;
		line-height: 0;
		color: #fff;
		font-size: 16px;
	}
</style>
